














import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
	data: {},
	components: {}
})
export default class Contact extends Vue {
	private readonly addressParts = ["in", "fo@", "ict", "-", "werkt", ".nl"];
	private addressIndex = 0;

	public get addressToShow(): string {
		return this.addressParts.filter((u, i) => i < this.addressIndex).join("");
	}

	public addressIndexMoveNext() {
		if (this.addressIndex < this.addressParts.length) {
			this.addressIndex++;
		}
	}
}
